import { useExercisePageStore } from '../stores/exercisePageStore';
import { useExerciseStore } from '../stores/exercisesStore';
import { useNewSubjectStore } from '../stores/newSubjectStore';

export type ExerciseCacheType = 'List' | 'Full';

export function hasExercisesLoaded(module: string, type: ExerciseCacheType): boolean {
  const snapshot =
    type === 'List'
      ? useExercisePageStore.getState().exercisesFilterList
      : useExercisePageStore.getState().fullExerciseFilterList;

  if (!snapshot) return false;
  if (snapshot.module !== module) return false;

  const favorite = useExerciseStore.getState().favorite;
  const unanswered = useExerciseStore.getState().unanswered;
  const wrongAnswer = useExerciseStore.getState().wrongAnswer;
  const rightAnswer = useExerciseStore.getState().rightAnswer;
  const difficulty = useExerciseStore.getState().difficulty;
  const selectedYear = useExerciseStore.getState().selectedYear;
  const institutionType = useExerciseStore.getState().institutionType;
  const trial = useExerciseStore.getState().trialOptions;
  const questions = useExerciseStore.getState().questionOptions;
  const isEnem = useExerciseStore.getState().isEnem;
  const selectedSubjects = useNewSubjectStore.getState().selectedSubjects;

  if ((snapshot.selectedSubjects ?? []).toString() !== selectedSubjects.toString()) {
    if (type === 'List') {
      useExerciseStore.getState().setPage(1);
    }
    return false;
  }

  if (snapshot.favorite !== favorite) return false;
  if (snapshot.unanswered !== unanswered) return false;
  if (snapshot.wrongAnswer !== wrongAnswer) return false;
  if (snapshot.rightAnswer !== rightAnswer) return false;
  if (snapshot.trial !== trial) return false;

  if (JSON.stringify(snapshot.difficulty ?? []) !== JSON.stringify(difficulty)) return false;
  if (JSON.stringify(snapshot.questions ?? []) !== JSON.stringify(questions)) return false;
  if (JSON.stringify(snapshot.isEnem ?? []) !== JSON.stringify(isEnem)) return false;
  if (JSON.stringify(snapshot.selectedYear ?? []) !== JSON.stringify(selectedYear)) return false;
  if (JSON.stringify(snapshot.institutionType ?? []) !== JSON.stringify(institutionType)) return false;

  return true;
}
